import { render, staticRenderFns } from "./ImportStock.vue?vue&type=template&id=b58b83ce&"
import script from "./ImportStock.vue?vue&type=script&lang=js&"
export * from "./ImportStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports